module.exports = __webpack_public_path__ + "img/sun.5c3bdc00.svg";